import { render, staticRenderFns } from "./BaseLoading.vue?vue&type=template&id=3c824b83&scoped=true"
import script from "./BaseLoading.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseLoading.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BaseLoading.vue?vue&type=style&index=0&id=3c824b83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c824b83",
  null
  
)

export default component.exports